import { defineComponent as _defineComponent } from 'vue'
import '../../types/globals';

import { Portal } from '@linusborg/vue-simple-portal';
import {
    nextTick,
    shallowRef,
    unref,
    watch,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'download-blob',
  props: {
    downloadAction: null,
    downloadParams: null,
    submit: null
  },
  setup(__props: any) {

const props = __props as {
    downloadAction?: string;
    downloadParams?: unknown;
    submit?: number;
}

const ROOT = __ROOT__;


const form = shallowRef<HTMLFormElement | undefined>();
const params = shallowRef<HTMLInputElement | undefined>();

watch(() => props.submit, () => {
    const _form = unref(form);
    const _params = unref(params);
    if(_form && _params) {
        //if we use vue auto updater with
        //computed(() => JSON.stringify(props.downloadParams));
        //DOM updates only after 3 nextTick in a row
        //so we insert this value manually, to insure it always up to date, before submit
        nextTick(() => {
            //wait for props update
            _form.action = `${ROOT}${props.downloadAction}`;
            _params.value = JSON.stringify(props.downloadParams);
            _form.submit();
        });
    }
});

return { __sfc: true,ROOT, props, form, params, Portal }
}

})